import { SearchCheck, ShieldCheck, Home, BadgeCheck, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/siteContent";

const ICONS = { SearchCheck, ShieldCheck, Home, BadgeCheck };

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 md:py-32 bg-[#F2FAF4] dark:bg-[#0E2A17]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="max-w-3xl">
          <span
            className="inline-block text-xs uppercase tracking-[0.18em] font-semibold text-[#1F8A3A]"
            data-testid="services-eyebrow"
          >
            What we do
          </span>
          <h2
            data-testid="services-heading"
            className="mt-4 font-display text-3xl md:text-5xl font-semibold tracking-tight text-[#0E2A17] dark:text-[#F2FAF4]"
          >
            End-to-end mold services for GTA homes.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#3F5549] dark:text-[#B9CDC0] leading-relaxed">
            From the first suspicious smell to lab-verified clearance — we
            handle every stage with calm, careful, code-aligned work.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-5 auto-rows-[260px]">
          {SERVICES.map((svc, i) => {
            const Icon = ICONS[svc.icon] || SearchCheck;
            return (
              <article
                key={svc.key}
                data-testid={`service-card-${svc.key}`}
                className={`group relative overflow-hidden rounded-3xl bg-white dark:bg-[#0A2513] border border-[#E3F5EA] dark:border-[#1A3925] p-7 md:p-8 flex flex-col justify-between hover:-translate-y-1 hover:shadow-xl transition-all duration-500 ${svc.span}`}
                style={{ animationDelay: `${i * 60}ms` }}
              >
                {svc.image && (
                  <div className="absolute inset-0 -z-0 overflow-hidden">
                    <img
                      src={svc.image}
                      alt=""
                      className="h-full w-full object-cover object-top opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-[1200ms] ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-white via-white/75 to-transparent" />
                  </div>
                )}
                <div className="relative z-10 flex items-start justify-between">
                  <div className="h-12 w-12 rounded-2xl bg-[#1F8A3A]/10 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-[#1F8A3A]" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-[#3F5549] dark:text-[#B9CDC0] opacity-0 group-hover:opacity-100 group-hover:text-[#1F8A3A] transition-all" />
                </div>
                <div className="relative z-10 mt-6">
                  <h3 className="font-display text-xl md:text-2xl font-semibold text-[#0E2A17] dark:text-[#F2FAF4]">
                    {svc.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium text-[#1F8A3A]">
                    {svc.short}
                  </p>
                  <p className="mt-3 text-sm md:text-base text-[#3F5549] dark:text-[#B9CDC0] leading-relaxed">
                    {svc.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
